import { getHnms } from '../actions/hnms';
const {createSlice} = require('@reduxjs/toolkit')
const initialState = {
    isLoading: false,
    Hospitallist:[],
    totalPages: 1,

  }

  const hnms = createSlice({
    name: 'hnms',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
      builder.addCase(getHnms.pending, (state) => {
        state.isLoading = true;
      });
      builder.addCase(getHnms.fulfilled, (state, action) => {
        state.isLoading = false;
        state.Hospitallist = action?.payload?.data || [] 
        state.totalPages = action?.payload?.total_pages 
        console.log(state.Hospitallist,'state.appsettingstate.appsetting');
        console.log(state.totalPages,'56565656512')
      });
      builder.addCase(getHnms.rejected, (state) => {
        state.isLoading = false;
      });
      
    },
  });
  
  export default hnms.reducer;